import { render } from "./createSingle.vue?vue&type=template&id=131c8492&scoped=true"
import script from "./createSingle.vue?vue&type=script&lang=js"
export * from "./createSingle.vue?vue&type=script&lang=js"

import "./createSingle.vue?vue&type=style&index=0&id=131c8492&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-131c8492"

export default script